import React from 'react';
import {Routes, Route, BrowserRouter, useLocation, Navigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import OpeningPage from '../pages/OpeningPage';
import SelectPersonaPage from '../pages/SelectPersonaPage';
import ShoppingCartPage from "../pages/ShoppingCartPage";
import ShoppingListPage from "../pages/ShoppingListPage";
import EditShoppingListPage from "../pages/EditShoppingListPage";
import ShoppingGoalPage from '../pages/ShoppingGoalPage';
import RateExperiencePage from "../pages/RateExperiencePage";
import GeneratingRoutePage from '../pages/GeneratingRoutePage';
import MorePage from '../pages/MorePage';
import MapPage from '../pages/MapPage';
import RouteMapPage from '../pages/RouteMapPage';
import BottomNavigationBar from '../global/components/BottomNavigation';

const PUBLIC_PATHS = ['/'];

const AppRouterContent = () => {
    const location = useLocation();
    const { loading } = useSelector((state: RootState) => state.app);
    const hideNavigationPaths = ['/', '/opening', '/route-map'];
    const showNavigation = !hideNavigationPaths.includes(location.pathname) && !loading && !location.pathname.includes('/edit/');

    const userId = typeof window !== 'undefined' ? localStorage.getItem('userId') : null;
    if (!PUBLIC_PATHS.includes(location.pathname) && !userId) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <Routes>
                <Route path="/" element={<SelectPersonaPage/>}/>
                <Route path="/opening" element={<OpeningPage/>}/>
                <Route path="/cart" element={<ShoppingCartPage/>}/>
                <Route path="/lists" element={<ShoppingListPage/>}/>
                <Route path="/lists/edit/:listId" element={<EditShoppingListPage/>}/>
                <Route path="/map" element={<MapPage/>}/>
                <Route path="/route-map" element={<RouteMapPage/>}/>
                <Route path="/shopping-goal" element={<ShoppingGoalPage/>}/>
                <Route path="/generating-route" element={<GeneratingRoutePage/>} />
                <Route path="/rate" element={<RateExperiencePage/>} />
                <Route path="/more" element={<MorePage/>} />
            </Routes>
            {showNavigation && <BottomNavigationBar />}
        </>
    );
};

const AppRouter = () => (
    <BrowserRouter>
        <AppRouterContent />
    </BrowserRouter>
)


export default AppRouter;